/**
 * @fileoverview Constants for CopilotBar scenario types.
 *
 * Defines the available scenario types that determine how the CopilotBar
 * is displayed and configured in different application contexts.
 *
 * @module CopilotBar/scenarios/constants
 */

/**
 * Enumeration of CopilotBar scenario types.
 *
 * Each scenario type corresponds to a specific context in which the CopilotBar
 * can be displayed, with its own layout and behavior configuration.
 *
 * @readonly
 * @enum {string}
 */
export const COPILOT_BAR_SCENARIOS = {
    /** CopilotBar displayed within a modal overlay for CRUD operations */
    CRUD_MODAL: 'CRUD_MODAL',

    /** CopilotBar displayed as a side panel pinned to the right for standard CRUD operations */
    STANDARD_CRUD: 'STANDARD_CRUD',

    /** CopilotBar open when the user is in the Dashboards section */
    DASHBOARDS: 'DASHBOARDS',

    // Future scenarios can be added here:
    // /** CopilotBar for analytics assistant features */
    // ANALYTICS: 'ANALYTICS',
    // /** CopilotBar for document processing assistant */
    // DOCUMENT_ASSISTANT: 'DOCUMENT_ASSISTANT',
    // /** CopilotBar for conversation summary features */
    // CONVERSATION_SUMMARY: 'CONVERSATION_SUMMARY',
};
